import styled from 'styled-components';

export const Wrapper = styled.div`
    font-weight: bold;
    font-size: 2rem;
    color: white;
    text-transform: uppercase;
`;
